angular.module('dnecom')
    .directive('validationPrice', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelController) {
                ngModelController.$validators.validationPrice = function (modelValue, viewValue) {
                    if (ngModelController.$isEmpty(modelValue)) {
                        return true;
                    }

                    if (isNaN(parseFloat(viewValue))) {
                        return false;
                    }

                    if (viewValue.indexOf('.') == -1) {
                        return true;
                    }

                    var decimalsLength = viewValue.split('.')[1].length;

                    return decimalsLength >= 1 && decimalsLength <= 2;

                }
            }
        };
    });


